import type { StringMap } from 'corgi-types';

export const enum OverlayStatus {
  Open = 'open',
  Closed = 'closed',
}

export const enum OverlayInteraction {
  Open = 'open',
  Close = 'close',
  Slide = 'slide',
  ChangeMainImage = 'change main image',
  TabChange = 'tab change',
}

export const enum DrawerInteraction {
  Open = 'open drawer',
  Close = 'close drawer',
}

export type TrackingParams = StringMap<string | number>;

export const enum Element {
  Icon = 'icon',
  Checkbox = 'checkbox',
  Button = 'button',
  Link = 'link',
  Switch = 'switch',
  InputWrapper = 'input-wrapper',
  DrawerBackdrop = 'drawer-backdrop',
  Image = 'image',
  Dropdown = 'dropdown',
  Input = 'input',
  Label = 'label',
  Escape = 'escape-key',
  BrowserBack = 'browser-back',
  Section = 'section',
}

export const enum NavigationParent {
  GlobalHeader,
  ShopInShopNav,
}

export const enum TrackingEventName {
  AdditionalServices = 'additional-services_click',
  CommonDrawerClick = 'common-disclaimer_click',
  AddToCardClick = 'add-to-cart_click',
  BannerVoucherClick = 'banner-voucher_click',
}

export const enum BannerVoucherV2Placement {
  BannerVoucherPdp = 'banner-voucher-pdp',
  BannerVoucherPdpDrawer = 'banner-voucher-pdp-drawer',
}
